
export default {

  state:{
    prenatal  : null,
    natal     : null,
    postnatal : null,
    aiepi     : null
  },

  mutations: {

    setSemPediatrica(state, newData){
      state.prenatal    = newData.prenatal;
      state.natal       = newData.natal;
      state.postnatal   = newData.postnatal;
      state.aiepi       = newData.aiepi; 
    },

    setPreNatales(state, data){
      state.prenatal = data
    },
    
    setNatales(state, data){
      state.natal = data
    },

    setPostNatales(state, data){
      state.postnatal = data
    },

    setAiepi(state, data){
      state.aiepi = data
    },

    resetSemPediatrica(state){
      state.prenatal  = null;
      state.natal     = null;
      state.postnatal = null;
      state.aiepi     = null;
    },
    
  }
}